(function(window, document) {
    const clearUserLocationData = () => {
        try {
            window.localStorage.removeItem('cn_location');
            window.localStorage.removeItem('cn_country');
            window.localStorage.removeItem('cn_anonymous');
            window.localStorage.removeItem('cn_success');
            window.localStorage.removeItem('cn_failed');
        } catch (ex) {
            if (console && console.error) {
                console.error(ex);
            }
        }
    };

    window.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.signup') || document.querySelector('.launchpad--login')) {
            clearUserLocationData();
        }
        const addressForm = document.querySelector('.address-form');
        if (addressForm && addressForm.addEventListener) {
            addressForm.addEventListener('submit', clearUserLocationData);
        }
    });
})(window, document);
